import { useFarmContext } from 'src/Elements/Farm'
import { useSystemInfoStorage } from 'src/Libs/system-data-handler/api/SystemDataFetching'
import { useTypedSelector } from 'src/State/RootReducer'

interface ReturnType {
  softwareVersion: string | undefined
  isLoading: boolean
}

/**
 * Hook to get the software version of the home power station
 */
export const useSoftwareVersion = (): ReturnType => {
  const storageId = useTypedSelector(state => state.storage.activeStorage)
  const { isFarm, farmMaster } = useFarmContext()
  const relevantStorageId = isFarm ? farmMaster?.storageId : storageId
  const { systemInfo, isLoading } = useSystemInfoStorage(relevantStorageId)
  const softwareVersion = systemInfo?.storage?.info?.sw_release

  return { softwareVersion, isLoading }
}
